import { TextCircle } from './components/textCircle/textCircle';

import template from './accordian.html';
import './accordian.scss';

export const Accordian = angular
    .module('checkout.components.accordian', [
        TextCircle
    ]).component('accordian', {
        template,
        transclude: {
            content: 'accordianContent',
            headerContent: '?accordianHeaderContent'
        },
        bindings: {
            stepNumber: '@',
            headingText: '<',
            open: '<',
            light: '<'
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/accordian/accordian.js